namespace Nobox {
    export namespace ChatroomsService {
        export const baseUrl = 'Chat/Chatrooms';

        export declare function Create(request: Serenity.SaveRequest<ChatroomsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ChatroomsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ChatroomsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ChatroomsListRequest, onSuccess?: (response: Serenity.ListResponse<ChatroomsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListWithoutTags(request: ChatroomsListRequest, onSuccess?: (response: Serenity.ListResponse<ChatroomsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListConversation(request: ChatroomsListRequest, onSuccess?: (response: Serenity.ListResponse<ChatroomsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function DetailRoom(request: Serenity.RetrieveRequest, onSuccess?: (response: any) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function DetailArchived(request: Serenity.RetrieveRequest, onSuccess?: (response: any) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RestoreArchived(request: Serenity.RetrieveRequest, onSuccess?: (response: any) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function MoveArchive(request: Serenity.RetrieveRequest, onSuccess?: (response: any) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function MarkResolved(request: Serenity.SaveRequest<ChatroomsRow>, onSuccess?: (response: any) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function getUnassignedArchived(request: Serenity.RetrieveRequest, onSuccess?: (response: any) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function getDataDefault(request: Serenity.ListRequest, onSuccess?: (response: any) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function JoinAgentAndSentMsg(request: JoinAgentAndSentMsgClass, onSuccess?: (response: any) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RemoveAgentFromConversation(request: RemoveAgentFromConversationClass, onSuccess?: (response: any) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function AddAgentToConversation(request: AddAgentToConversationCLass, onSuccess?: (response: any) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Chat/Chatrooms/Create",
            Update = "Chat/Chatrooms/Update",
            Retrieve = "Chat/Chatrooms/Retrieve",
            List = "Chat/Chatrooms/List",
            ListWithoutTags = "Chat/Chatrooms/ListWithoutTags",
            ListConversation = "Chat/Chatrooms/ListConversation",
            DetailRoom = "Chat/Chatrooms/DetailRoom",
            DetailArchived = "Chat/Chatrooms/DetailArchived",
            RestoreArchived = "Chat/Chatrooms/RestoreArchived",
            MoveArchive = "Chat/Chatrooms/MoveArchive",
            MarkResolved = "Chat/Chatrooms/MarkResolved",
            getUnassignedArchived = "Chat/Chatrooms/getUnassignedArchived",
            getDataDefault = "Chat/Chatrooms/getDataDefault",
            JoinAgentAndSentMsg = "Chat/Chatrooms/JoinAgentAndSentMsg",
            RemoveAgentFromConversation = "Chat/Chatrooms/RemoveAgentFromConversation",
            AddAgentToConversation = "Chat/Chatrooms/AddAgentToConversation"
        }

        [
            'Create', 
            'Update', 
            'Retrieve', 
            'List', 
            'ListWithoutTags', 
            'ListConversation', 
            'DetailRoom', 
            'DetailArchived', 
            'RestoreArchived', 
            'MoveArchive', 
            'MarkResolved', 
            'getUnassignedArchived', 
            'getDataDefault', 
            'JoinAgentAndSentMsg', 
            'RemoveAgentFromConversation', 
            'AddAgentToConversation'
        ].forEach(x => {
            (<any>ChatroomsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
